/**
 * WEB-927 атом 3: колонка контента экрана — единственный узел, который двигают
 * оси раскладки. Один компонент на обе поверхности (квиз и пейволл), чтобы
 * «в превью одно, в проде другое» не могло возникнуть в принципе.
 *
 * При легаси-осях (top + center) обёртка НЕ появляется: лишний div в потоке —
 * это уже изменение разметки выкаченных воронок (по узлам потока цепляются
 * отступы блоков и селекторы), а атом обещает их не трогать.
 */
import React from 'react';
import type { ScreenAxes } from './screenLayoutStyles';
import { screenAlignsContent, screenContentColumnStyle } from './screenLayoutStyles';

interface ScreenContentColumnProps {
  layout: ScreenAxes;
  /** data-testid обёртки; у поверхностей он свой (квиз/пейволл). */
  testId: string;
  children: React.ReactNode;
}

export function ScreenContentColumn({
  layout,
  testId,
  children,
}: ScreenContentColumnProps): React.ReactElement {
  if (!screenAlignsContent(layout)) {
    return <>{children}</>;
  }
  return (
    <div data-testid={testId} style={screenContentColumnStyle(layout)}>
      {children}
    </div>
  );
}
